function parseProbeStatus(device) {
  const raw = (device?.wifiProbeStatus || device?.wifiStatus || device?.probeStatus || device?.status || '').toString().toLowerCase();
  if (raw.includes('recover')) return 'recovering';
  if (raw.includes('down') || raw.includes('fail') || raw.includes('offline')) return 'down';
  return 'up';
}

function parseWifiStatus(device) {
  const raw = (device?.wifiStatus || device?.wifi_mode || device?.wifiState || device?.wifi || '').toString().toLowerCase();
  if (raw.includes('monitor')) return 'up';
  if (raw.includes('inactive') || raw.includes('error') || raw.includes('down')) return 'down';
  return 'down';
}

function parseBluetoothStatus(device) {
  const raw = (device?.bluetoothStatus || device?.btStatus || device?.bluetooth || '').toString().toLowerCase();
  if (raw.includes('scanning')) return 'up';
  if (raw.includes('error') || raw.includes('down')) return 'down';
  return 'down';
}

function parseConnectionStatus(device, probeStatus) {
  if (device?.isActive === false) return 'offline';
  const raw = (device?.connection || device?.connectionStatus || device?.status || '').toString().toLowerCase();
  if (raw.includes('offline')) return 'offline';
  if (probeStatus === 'down') return 'offline';
  return 'connected';
}

export function getNormalizedDevices(apiDevices = []) {
  const source = Array.isArray(apiDevices) ? apiDevices : [];
  return source.map((device, index) => {
    const screenId = device.screenId || device.screen_id || device.screen || device.screenName || null;
    const id = screenId || device.id || `device-${index + 1}`;
    const probeStatus = parseProbeStatus(device);
    const connection = parseConnectionStatus(device, probeStatus);
    const wifiStatus = parseWifiStatus(device);
    const bluetoothStatus = parseBluetoothStatus(device);
    const lastHealthcheck = device.lastHealthcheck || device.lastHealthCheck || device.lastCheck || null;
    return {
      raw: device,
      id,
      name: device.hostname || device.name || screenId || id,
      screenId,
      raspId: device.raspId ?? device.rasp_id ?? null,
      connection,
      probeStatus,
      wifiStatus,
      bluetoothStatus,
      lastSeen: device.lastSeen || device.lastHeartbeatAt || device.lastHeartbeat || device.last_heartbeat_at || lastHealthcheck || null,
      lastUpdater: device.lastUpdater || device.updatedBy || null,
      lastHealthcheck,
      uptime: device.uptime || device.uptimeSeconds || device.uptime_seconds || null,
      branch: device.branch || device.gitBranch || device.git_branch || device.releaseBranch || null,
      sha: device.sha || device.gitSha || device.git_sha || device.commitSha || device.commit_sha || device.commit || device.revision || null,
      createdAt: device.createdAt || device.created_at || device.created || null,
      freemem: device.freemem ?? device.freeMem ?? device.free_mem ?? null,
      totalmem: device.totalmem ?? device.totalMem ?? device.total_mem ?? null,
      loadAverage: device.loadAverage ?? device.load_avg ?? null,
      temperature: device.temperature ?? device.temp ?? device.cpuTemp ?? device.cpu_temperature ?? null,
      timeline: device.timeline || device.logs || [],
    };
  });
}

export function summarizeFleet(devices) {
  const total = devices.length;
  const online = devices.filter(d => d.connection === 'connected' && d.probeStatus === 'up').length;
  const offline = Math.max(total - online, 0);
  return { total, online, offline };
}
